import { render } from "./ArtifactScoreFormula.vue?vue&type=template&id=79e749d5&scoped=true&ts=true"
import script from "./ArtifactScoreFormula.vue?vue&type=script&lang=ts"
export * from "./ArtifactScoreFormula.vue?vue&type=script&lang=ts"

import "./ArtifactScoreFormula.vue?vue&type=style&index=0&id=79e749d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e749d5"]])

export default __exports__